(() => {
  const catalogs = new Map();
  const normal = value => String(value).normalize('NFKC').toLowerCase().replace(/[″”“"]/g,' inch ').replace(/\+/g,' plus ').replace(/[-–—]/g,' ').replace(/[^a-z0-9.]+/g,' ').replace(/\s+/g,' ').trim();
  function matches(label, records) {
    const text = normal(label.replace(/^Samsung /i, 'Galaxy ').replace(/\s*[—–-]\s*pre.order.*$/i,''));
    const direct = records.filter(record => normal(record.name) === text);
    if (direct.length) return direct;
    if (text === 'iphone 17 air') return records.filter(record => record.name === 'iPhone Air');
    if (text.startsWith('iphone')) return [];
    if (/^\d{2}mm/.test(text)) {
      const size = Number(text.match(/^\d{2}/)[0]);
      const ranges = kind => {
        const match = label.match(new RegExp(kind + '\\s+(\\d+)(?:[–-](\\d+))?', 'i'));
        return match ? [Number(match[1]), Number(match[2] || match[1])] : null;
      };
      const series = ranges('Series'), ultra = ranges('Ultra'), se = ranges('SE');
      return records.filter(record => {
        if (record.family !== 'watch' || record.case_size !== size) return false;
        if (record.series && series && record.series >= series[0] && record.series <= series[1]) return true;
        // Labels can list two series ranges, such as Series 1–3 / 10–12.
        if (record.series && /Series/i.test(label)) {
          const extra = label.match(/\/\s*(\d+)[–-](\d+)/);
          if (extra && record.series >= Number(extra[1]) && record.series <= Number(extra[2])) return true;
        }
        if (record.ultra && ultra && record.ultra >= ultra[0] && record.ultra <= ultra[1]) return true;
        return Boolean(record.se && se && record.se >= se[0] && record.se <= se[1]);
      });
    }
    if (!text.startsWith('ipad')) return [];
    const family = text.startsWith('ipad pro') ? 'ipad pro' : text.startsWith('ipad air') ? 'ipad air' : text.startsWith('ipad mini') ? 'ipad mini' : 'ipad';
    const sizes = (label.split(/[—–]\s/)[0].match(/\d+(?:\.\d+)?(?=[″”"])/g)||[]).map(Number);
    const chips = [...label.matchAll(/\bM(\d)(?:\s*[–-]\s*M(\d))?/gi)].flatMap(match => {
      const from=Number(match[1]),to=Number(match[2]||match[1]);
      return Array.from({length:Math.max(0,to-from+1)},(_,i)=>'m'+(from+i));
    });
    const genMatch = label.match(/\bGen\s+(\d+(?:\s*[\/–-]\s*\d+)*)/i) || label.match(/\b(\d+(?:\s*[\/–-]\s*\d+)*)\s+Gen\b/i);
    const gens = [];
    if(genMatch){
      for(const part of genMatch[1].split('/')){
        const pair=part.split(/[–-]/).map(Number);
        for(let n=pair[0];n<=(pair[1]||pair[0]);n++)gens.push(n);
      }
    }
    if(family==='ipad air' && /air\s*3\b/.test(text))gens.push(3);
    return records.filter(record => {
      if(record.family!=='ipad')return false;
      const name=normal(record.name);
      const rf=name.startsWith('ipad pro')?'ipad pro':name.startsWith('ipad air')?'ipad air':name.startsWith('ipad mini')?'ipad mini':'ipad';
      if(rf!==family)return false;
      const size=Number(name.match(/(\d+(?:\.\d+)?) inch/)?.[1]||0);
      if(sizes.length&&size&&!sizes.includes(size))return false;
      const chip=record.name.match(/\((M\d)\)/i)?.[1]?.toLowerCase();
      const gen=Number(record.name.match(/\((\d+)(?:st|nd|rd|th) generation\)/)?.[1]||0);
      if(chip && chips.includes(chip))return true;
      if(gen && gens.includes(gen))return true;
      if(family==='ipad' && gens.includes(11) && record.name==='iPad (A16)')return true;
      if(family==='ipad mini' && gens.includes(7) && record.name==='iPad mini (A17 Pro)')return true;
      if(family==='ipad air' && gens.includes(5) && record.name==='iPad Air (5th generation)')return true;
      if(family==='ipad pro' && sizes.includes(10.5) && /2017/.test(text) && record.name==='iPad Pro (10.5-inch)')return true;
      if(family==='ipad pro' && gens.includes(1) && sizes.includes(11) && record.name==='iPad Pro 11-inch')return true;
      if(family==='ipad pro' && gens.includes(1) && sizes.includes(12.9) && record.name==='iPad Pro (12.9-inch)')return true;
      return false;
    });
  }

  if(customElements.get('evolved-device-compatibility'))return;
  customElements.define('evolved-device-compatibility',class extends HTMLElement {
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();
      queueMicrotask(()=>{if(this.isConnected)this.setup();});
    }
    disconnectedCallback(){this.controller?.abort();}
    groupRows(){
      const signal=this.controller.signal;
      const list=this.list||(this.list=this.querySelector('.ev-model-reference'));
      this.rows.forEach(row=>list.append(row));
      this.querySelectorAll('.ev-model-family').forEach(group=>group.remove());
      this.id=list.id||this.id;list.removeAttribute('id');this.groups=[];
      const families=new Map();
      this.rows.forEach(row=>{
        const name=row.dataset.modelOption;
        const family=name.match(/^iPhone\s+\d+/i)?.[0]||name.match(/^iPad(?: Pro| Air| mini)?/i)?.[0]||name.match(/^(?:Samsung|Galaxy) S\d+/i)?.[0]?.replace(/^Samsung /,'Galaxy ')||name.match(/^Apple Watch (?:Series \d+|SE(?: \d+)?|Ultra(?: \d+)?)/)?.[0]||name;
        if(!families.has(family))families.set(family,[]);families.get(family).push(row);
      });
      families.forEach((rows,family)=>{
        const group=document.createElement('details');group.className='ev-model-family';
        group.setAttribute('name','ev-device-family-'+this.dataset.productId+'-'+this.dataset.optionPosition);
        group.addEventListener('toggle',()=>{if(group.open)this.groups.forEach(other=>{if(other!==group)other.open=false;});},{signal});
        const summary=document.createElement('summary');summary.textContent=family;
        const inner=document.createElement('ul');inner.className='ev-model-reference';rows.forEach(row=>inner.append(row));
        group.append(summary,inner);list.before(group);this.groups.push(group);
      });list.hidden=true;
    }
    filter(query){
      const text=normal(query),compact=text.replace(/ /g,'');let count=0;
      this.rows.forEach(row=>{
        const recordMatch=(row._evRecords||[]).some(record=>record.code_prefix&&record.codes.some(code=>compact.startsWith(normal(code).replace(/ /g,''))));
        const nameMatch=normal(row.dataset.modelOption).includes(text);
        row.hidden=!(nameMatch||normal(row.textContent).includes(text)||recordMatch);
        if(!row.hidden)count++;
        row.querySelectorAll('[data-model-codes] p').forEach(line=>{line.hidden=Boolean(text)&&!nameMatch&&!normal(line.textContent).includes(text)&&!recordMatch;});
      });
      let opened=false;
      this.groups.forEach(group=>{group.hidden=![...group.querySelectorAll('[data-model-option]')].some(row=>!row.hidden);group.open=Boolean(text)&&!group.hidden&&!opened;if(group.open)opened=true;});
      this.querySelector('[data-model-no-results]').hidden=count>0;
      const status=this.querySelector('[data-model-status]');if(status)status.textContent=text ? count+' matching '+(count===1?'option':'options') : '';
    }
    async setup(){
      const signal=this.controller.signal;
      this.rows=[...this.querySelectorAll('[data-model-option]')];this.groupRows();
      const input=this.querySelector('input[type="search"]');
      input?.addEventListener('input',event=>this.filter(event.target.value),{signal});
      document.addEventListener('variant:change',event=>{
        const main=document.querySelector('.shopify-section--main-product');if(!main?.contains(event.target))return;
        const value=event.detail?.variant?.options?.[Number(this.dataset.optionPosition)-1];
        if(value)this.rows.forEach(row=>row.toggleAttribute('data-current',row.dataset.modelOption===value));
      },{signal});
      try{
        const url=this.dataset.catalogUrl;
        if(!catalogs.has(url))catalogs.set(url,fetch(url).then(response=>{if(!response.ok)throw Error('reference unavailable');return response.json();}).catch(error=>{catalogs.delete(url);throw error;}));
        const data=await catalogs.get(url);if(signal.aborted)return;
        if(this.dataset.catalogFamilies){
          const families=this.dataset.catalogFamilies.split(',');
          const list=this.list||(this.list=this.querySelector('.ev-model-reference'));
          data.records.filter(record=>families.includes(record.family)).forEach(record=>{
            const row=document.createElement('li');row.dataset.modelOption=record.name;
            const title=document.createElement('strong');title.textContent=record.name;
            const codes=document.createElement('div');codes.dataset.modelCodes='';row.append(title,codes);list.append(row);this.rows.push(row);
          });this.groupRows();
        }
        for(const row of this.rows){
          const records=matches(row.dataset.modelOption,data.records);row._evRecords=records;
          const target=row.querySelector('[data-model-codes]');target.replaceChildren();
          for(const record of records){
            const line=document.createElement('p');
            const name=document.createElement('span');name.textContent=record.name;
            const numbers=document.createElement('span');numbers.textContent=record.codes.join(', ')+(record.code_prefix?'… (regional suffix varies)':'');
            line.append(name,numbers);target.append(line);
          }
        }
        this.querySelector('[data-reference-loading]')?.remove();
        if(input?.value)this.filter(input.value);
      }catch{/* Existing device options and manufacturer links remain usable. */}
    }
  });
})();
